import { Breadcrumb } from "@gull";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import { exportUserLog, getUserLog } from "app/services/memberService";
import queryString from "app/services/queryStringService";
import config from "config.json";
import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Helmet } from "react-helmet";
import { AiFillFileExcel } from "react-icons/ai";
import { MdOutlineRefresh, MdSearch } from "react-icons/md";
import MemberAutoComplete from "./Components/MemberAutoComplete";

const { dateTimeFormat } = config;
const Log = () => {
  const { canAdd, canEdit, canDelete } = usePagePermission();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");

  const [agentValue, setAgentValue] = useState();
  const [toDate, setToDate] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [bookingStatus, setBookingStatus] = useState("");
  const dateFormatter = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  const columns = [
    {
      dataField: "action",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "createdAt",
      text: "Activity Date & Time",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "module",
      text: "Module",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadLog = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      memberId: agentValue,
      userAction: bookingStatus,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getUserLog(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadLog();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadLog();
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );
  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setAgentValue();
    setBookingStatus("");
    setSelectedValue(null);
  };
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;

      case "agentValue":
        setAgentValue(value);
        break;

      case "bookingStatus":
        setBookingStatus(value);
        break;

      default:
        break;
    }
  };

  const exportAllLog = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      memberId: agentValue,
      userAction: bookingStatus,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportUserLog(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllLog();
    }, 10);
  };
  return (
    <>
      <Helmet>
        <title>User Activity Log</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "User Activity Log" }]}></Breadcrumb>
      <div className="bookingList-header" style={{ marginBottom: 20 }}>
        <Row>
          <div className={"show"}>
            <div className="card card-body rounded border mb-1">
              <Row>
                {/* Date From */}
                <Col md={2} col={12}>
                  <label>Date From</label>
                  <input
                    type="date"
                    className="form-control"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>
                {/* Date To */}
                <Col md={2} col={12}>
                  <label>Date To</label>
                  <input
                    type="date"
                    className="form-control"
                    name="toDate"
                    value={toDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </Col>

                {/* Booking Status */}
                <Col md={2} col={12}>
                  <label>Activity Type</label>
                  <select
                    className="form-select"
                    name="bookingStatus"
                    value={bookingStatus}
                    onChange={handleSearchChanges}
                  >
                    <option value="">Select option</option>

                    <option value="Login">Login</option>
                    <option value="Login Otp Verification">
                      Login OTP Verification
                    </option>
                    <option value="User Password Change">
                      User Password Change
                    </option>
                    <option value="Requisition">Requisition</option>
                    <option value="Credit Requisition">
                      Credit Requisition
                    </option>
                    <option value="User Logo Upload">User Logo Upload</option>
                    <option value="Sub User Add">Sub User Add</option>
                    <option value="Online Wallet Recharge">
                      Online Wallet Recharge
                    </option>
                    <option value="Flight Search">Flight Search</option>
                    <option value="Flight Fare Quotes">
                      Flight Fare Quotes
                    </option>
                    <option value="Flight Review">Flight Review</option>
                    <option value="Flight Booking">Flight Booking</option>
                    <option value="Flight Hold Booking">
                      Flight Hold Booking
                    </option>
                    <option value="Flight Hold Confirm">
                      Flight Hold Confirm
                    </option>
                  </select>
                </Col>
                {/* Agency */}
                <Col md={3} col={12}>
                  <label>Agency</label>
                  <MemberAutoComplete
                    selectedValue={selectedValue}
                    setSelectedValue={setSelectedValue}
                    name="agentValue"
                    setState={setAgentValue}
                  />
                </Col>
                {/* Action Buttons */}
                <Col md={3} className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-outline-primary me-2"
                    onClick={handleSearch}
                  >
                    <MdSearch size={18} />
                  </button>

                  <button
                    className="btn btn-outline-primary  me-2"
                    onClick={refreshFilter}
                  >
                    <MdOutlineRefresh size={18} />
                  </button>
                  <Button
                    variant="primary"
                    onClick={handleExport}
                    disabled={!dataCount}
                  >
                    <AiFillFileExcel size={15} />
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
      <div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="uniqueIdentity"
              data={data}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
};

export default Log;
